import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class LetterIcon extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    size: PropTypes.oneOf(['xsm', 'sm', 'md', 'lg', 'xlg']),
    maxChars: PropTypes.number,
  }

  static defaultProps = {
    size: 'md',
    maxChars: 2,
  }

  get classNames() {
    const { className, size } = this.props;

    return classNames('letter-icon', {
      'is-xsmall': size === 'xsm',
      'is-small': size === 'sm',
      'is-medium': size === 'md',
      'is-large': size === 'lg',
      'is-xlarge': size === 'xlg',
      [className]: className,
    });
  }

  get initials() {
    const { text, maxChars } = this.props;
    if (!text) return '';

    const parts = text.trim().split(/\s+/).filter(Boolean);
    let chars = '';

    if (parts.length >= 2) {
      chars = (parts[0][0] || '') + (parts[1][0] || '');
    } else if (parts.length === 1) {
      chars = parts[0].slice(0, maxChars);
    }

    return chars.toUpperCase();
  }

  render() {
    return (
      <div className={this.classNames}>
        {this.initials}
      </div>
    );
  }
}